/* eslint-disable @typescript-eslint/no-explicit-any */
function flattenQuery(
  query: { [key: string]: any },
  keyQuery?: string,
): { [key: string]: string }[] {
  const keys = Object.keys(query)
  const queries = keys.reduce<{ [key: string]: string }[]>((arr, key) => {
    const value: string | string[] = query[key]
    const strKey = `${keyQuery ? `${keyQuery}.` : ''}${key}`

    // Is Array<string>
    if (typeof value === 'object' && value.length > 0) {
      const arrValue: string = value
        .map((v: string) => encodeURI((v !== null && JSON.stringify(v)) || ''))
        .join(',')
      return [...arr, { [strKey]: arrValue }]
    }

    // Is Oject
    if (typeof value === 'object') {
      return [...arr, ...flattenQuery(value, strKey)]
    }

    // String
    return [...arr, { [strKey]: encodeURI(value) }]
  }, [])

  return queries
}

/**
 * Retorna um objeto no formato queryString params
 * @example
 * From:
 * {
 *   "sort": {
 *       "data": -1,
 *       "slug": {
 *           "$eq": [
 *               "teste",
 *               "teste2"
 *           ]
 *       }
 *   },
 *   "query": {
 *       "data": {
 *           "slug": {
 *               "$eq": "olha"
 *           }
 *       }
 *   }
 * }
 * Result:
 * 'sort.data=-1&sort.slug.$eq=teste,teste2&query.data.slug.$eq=olha'
 * @param query
 * @returns
 */
export const objectToQueryString = (query: { [key: string]: any }) =>
  flattenQuery(query).reduce(
    (obj, value) => ({
      ...obj,
      ...value,
    }),
    {},
  )
